import { useMemo } from 'react';

import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { hardcodedEdgeCacheableGlobalAnnouncements } from '@rover/react-lib/src/factories/fetchGlobalAnnouncementsResponseFactory';
import { selectors as globalAnnouncementsSelectors } from '@rover/react-lib/src/redux/ducks/globalAnnouncements.duck';
import {
  GlobalAnnouncements,
  useApiAnnouncementsGlobalList,
} from '@rover/rsdk/src/apiClient/latest';

import useDucks from './useDucks';

export type GlobalAnnouncementsData = {
  globalAnnouncements: GlobalAnnouncements[] | null | undefined;
};

const selector = (state): GlobalAnnouncementsData => ({
  globalAnnouncements: globalAnnouncementsSelectors.getGlobalAnnouncements(state),
});

const useGlobalAnnouncementsShim = (): GlobalAnnouncementsData => {
  let globalAnnouncements: GlobalAnnouncements[] | null | undefined;

  const hardcodedAnnouncements = useMemo(() => hardcodedEdgeCacheableGlobalAnnouncements(), []);
  const { isReactQueryRoute, pageName, suppressGlobalAnnouncements } = usePageContext();
  const { data } = useApiAnnouncementsGlobalList(undefined, {
    query: { enabled: isReactQueryRoute },
  });

  const { data: selectedData } = useDucks({ selector });

  if (pageName === 'seo-city-landing') {
    globalAnnouncements = hardcodedAnnouncements;
  } else if (suppressGlobalAnnouncements) {
    globalAnnouncements = null;
  } else if (isReactQueryRoute) {
    globalAnnouncements = data?.results;
  } else {
    globalAnnouncements = selectedData.globalAnnouncements;
  }

  return { globalAnnouncements };
};

export default useGlobalAnnouncementsShim;
